// extracted by mini-css-extract-plugin
module.exports = {"logo":"styles_logo__1HGbJ","text":"styles_text__CrJ_d"};